import { render, staticRenderFns } from "./TableColumns.vue?vue&type=template&id=e4f95de0&"
import script from "./TableColumns.vue?vue&type=script&lang=js&"
export * from "./TableColumns.vue?vue&type=script&lang=js&"
import style0 from "./TableColumns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports